import { del, get, post } from 'lib/API';
import Company, { CompaniesList, CompanyHierarchy } from 'data/Company';

export const loadCompanies = async (
  args: any[],
  { token }: any
): Promise<CompaniesList> => {
  const [size, page, offset, vendorId] = args;
  const businessUnitId = args[13];

  return await get('v1/companies', token, { size, page, offset, vendorId, businessUnitId });
};

export const loadCompany = async ({
  companyId,
  token
}: any): Promise<Company> => {
  return await get(`v1/companies/${companyId}`, token);
};

export const loadCompanyDefer = async (
  [companyId]: any[],
  { token }: any
): Promise<Company> => {
  return await get(`v1/companies/${companyId}`, token);
};

export const loadHierarchy = async ([companyId]: any, { token }: any): Promise<CompanyHierarchy> => {
  return await get(`v1/companies/hierarchy/${companyId}`, token);
};

export const assignBusinessUnitToCompany = async (
  [businessUnitId, companyId]: any[],
  { token }: any
): Promise<any> => {
  return await post(`v1/companies/${companyId}/businessUnit/${businessUnitId}`, token);
};

export const removeBusinessUnitFromCompany = async (
  [companyId]: any[],
  { token }: any
): Promise<any> => {
  return await del(`v1/companies/${companyId}/businessUnit`, token);
};

export const loadAffiliateCompanies = async (
  [brandCode, vendorId, offset, size]: any[],
  { token }: any
): Promise<{ companies: any[]; totalCount: number }> => {
  return await get('v1/companies/affiliate', token, { brandCode, vendorId, offset, size });
};
